module.exports = __webpack_public_path__ + "static/img/delete.79c5a50c.svg";